import GET from "./GET";

const getApiUrl = () =>
	GET("environment") === "development"
		? "http://localhost:6543"
		: GET("environment") === "staging"
		? "https://consumer.disconetwork-staging.com"
		: "https://widget2.disconetwork.com";

export default getApiUrl;
